"use client";

import React from "react";
import { MapPin, ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const projects = [{
  id: 1,
  title: "Industrial Waterproofing",
  location: "Manchester Logistics Hub",
  categories: ["Industrial"],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/roofing_industrial_manchester.png",
  heightClass: "h-[450px]",
  link: "/OurCraftsmanshipPage"
}, {
  id: 2,
  title: "Residential Slate Restoration",
  location: "Surrey Estate",
  categories: ["Residential"],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/roofing_residential_surrey.png",
  heightClass: "h-[550px]",
  link: "/OurCraftsmanshipPage"
}, {
  id: 3,
  title: "Commercial Flat Roof",
  location: "London Tech Center",
  categories: ["Commercial"],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/roofing_commercial_london.png",
  heightClass: "h-[500px]",
  link: "/OurCraftsmanshipPage"
}, {
  id: 4,
  title: "Weatherproofing Seal",
  location: "Birmingham Factory",
  categories: ["Industrial"],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/roofing_industrial_birmingham.png",
  heightClass: "h-[600px]",
  link: "/OurCraftsmanshipPage"
}, {
  id: 5,
  title: "Modern Home Insulation",
  location: "Oxford Residence",
  categories: ["Residential"],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/roofing_residential_oxford.png",
  heightClass: "h-[480px]",
  link: "/OurCraftsmanshipPage"
}, {
  id: 6,
  title: "Retail Complex Roofing",
  location: "Leeds Shopping Plaza",
  categories: ["Commercial"],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/roofing_commercial_leeds.png",
  heightClass: "h-[520px]",
  link: "/OurCraftsmanshipPage"
}];
const filters = ["All", "Residential", "Commercial", "Industrial"];
export default function ThePortfolio() {
  return <section data-section-id="222021" id="project-highlights" className="py-24 dark bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="font-default text-3xl md:text-5xl font-extrabold text-foreground mb-6 tracking-tighter uppercase">
            Project Highlights
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            A showcase of our structural precision and high-performance roofing solutions across residential, commercial, and industrial sectors.
          </p>
        </div>

        <Tabs defaultValue="All" className="w-full">
          <div className="flex justify-center mb-12 overflow-x-auto pb-4 hide-scrollbar">
            <TabsList className="bg-muted/30 p-1.5 rounded-none border border-border/50 inline-flex h-auto">
              {filters.map((filter, index) => <TabsTrigger key={filter} value={filter} data-index={index} className="rounded-none px-6 py-2.5 text-sm md:text-base font-mono transition-all data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-none">
                  {filter}
                </TabsTrigger>)}
            </TabsList>
          </div>

          {filters.map((tab, tabIndex) => <TabsContent key={tab} value={tab} data-index={tabIndex} className="mt-0 outline-none">
              <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
                {projects.filter(p => tab === "All" || p.categories.includes(tab)).map((project, i) => <Link key={project.id} to={project.link} className="block break-inside-avoid mb-6 group" data-index={i}>
                      <Card className={`relative overflow-hidden rounded-none border border-border/20 w-full ${project.heightClass} shadow-none group-hover:shadow-2xl transition-all duration-500`}>
                        <img src={project.image} alt={project.title} className="absolute inset-0 w-full h-full object-cover grayscale-[0.3] transition-transform duration-700 group-hover:scale-110 group-hover:grayscale-0" />
                        
                        {}
                        <div className="absolute bottom-0 inset-x-0 bg-background/90 backdrop-blur-sm p-6 border-t border-primary/20 translate-y-2 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                          <div className="flex justify-between items-end gap-4">
                            <div className="flex-1">
                              <h3 className="font-default text-xl font-bold text-foreground mb-2 line-clamp-1 uppercase tracking-tight">
                                {project.title}
                              </h3>
                              <p className="text-xs text-primary flex items-center gap-1.5 font-mono uppercase">
                                <MapPin className="w-3 h-3 shrink-0" />
                                <span className="line-clamp-1">{project.location}</span>
                              </p>
                            </div>
                            <Button variant="secondary" size="icon" className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 transition-colors shrink-0" asChild>
                              <span>
                                <ArrowUpRight className="w-4 h-4" />
                              </span>
                            </Button>
                          </div>
                        </div>
                      </Card>
                    </Link>)}
              </div>
            </TabsContent>)}
        </Tabs>
      </div>
    </section>;
}